import React from "react"
import { EyeOff, LayoutTemplate, Users, Wallet, Unplug, BarChart3 } from "lucide-react"
import SectionHeading from "./SectionHeading.jsx"

const CHALLENGES = [
  {
    icon: EyeOff,
    title: "Poor search visibility",
    text: "Competitors appear first when customers search for what you do.",
  },
  {
    icon: LayoutTemplate,
    title: "A website you have outgrown",
    text: "Your site no longer reflects the quality, scale or direction of the business.",
  },
  {
    icon: Users,
    title: "Low-quality enquiries",
    text: "Too many tyre-kickers, not enough of the customers you actually want.",
  },
  {
    icon: Wallet,
    title: "Ineffective marketing spend",
    text: "Advertising budget goes out each month without a clear line to new work.",
  },
  {
    icon: Unplug,
    title: "Disconnected systems",
    text: "Enquiries, bookings and customer details are copied between tools by hand.",
  },
  {
    icon: BarChart3,
    title: "Limited insight",
    text: "No reliable view of what your website and campaigns are really delivering.",
  },
]

export default function ChallengesSection() {
  return (
    <section
      id="challenges"
      aria-labelledby="challenges-heading"
      className="scroll-mt-24 bg-brand-bg py-20 sm:py-24"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <SectionHeading
          id="challenges-heading"
          eyebrow="The challenge"
          title="Your business has evolved. Has your digital presence kept pace?"
          lead="Established businesses often find their online presence is holding them back in ways that are easy to miss."
        />

        <ul className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3">
          {CHALLENGES.map(({ icon: Icon, title, text }) => (
            <li key={title} className="flex gap-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-brand-primary shadow-card">
                <Icon aria-hidden="true" className="h-5 w-5" />
              </span>
              <div>
                <h3 className="font-semibold text-brand-heading">{title}</h3>
                <p className="mt-1 text-brand-textSoft">{text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
